export default {
  jsonSizeOf (object) {
    return JSON.stringify(object).length
  }
}
